const requireModule = require.context('.', false, /\.gql$/)
const modules = {}

requireModule.keys().forEach((fileName) => {
  const moduleName = fileName.replace(/(\.\/|\.gql)/g, '')
  modules[moduleName] = requireModule(fileName)
})

export default modules
